import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  encodeAsBase64(file: File, removePrefix: boolean = true): Observable<string> {
    return new Observable<string>(observer => {
      const fileReader: FileReader = new FileReader();
      fileReader.onloadend = () => {
        if (fileReader.result && !(fileReader.result instanceof ArrayBuffer)) {
          const fileContent = removePrefix ? fileReader.result.split('base64,', 2)[1] : fileReader.result;
          observer.next(fileContent);
          observer.complete();
        } else {
          observer.error(new Error('File encoding failed'));
        }
      };
      fileReader.onerror = () => observer.error(new Error('File encoding failed'));
      fileReader.readAsDataURL(file);
    });
  }

  decodeFromBase64(file: string, fileName: string): Observable<File> {
    return from(fetch(file)).pipe(
      switchMap(response => from(response.blob())),
      map(blob => new File([blob], fileName, { type: file.split(';')[0].split(':')[1] }))
    );
  }
}
